import { OrgEnvironmentType } from '../enums/organization';

export enum ToolConfigType {
  System = 'system',
  UserEnvironment = 'user_environment',
  UserOrganization = 'user_organization',
}

export enum ToolConfigDataTypeAccess {
  None = 'none',
  Read = 'read',
  Write = 'write',
}
export interface ToolConfigDataAccess {
  metadata: ToolConfigDataTypeAccess;
  personal_setup_data: ToolConfigDataTypeAccess;
  user_data: ToolConfigDataTypeAccess;
  business_data: ToolConfigDataTypeAccess;
}

export interface ToolConfig {
  id: string;
  is_overridable?: boolean;
  data_access: ToolConfigDataAccess;
  type: ToolConfigType;
  cirra_user_id: string | null | undefined;
  cirra_organization_id: string | null | undefined;
  salesforce_environment: OrgEnvironmentType;
  salesforce_organization_id: string | null | undefined;
  is_connection_creation_restricted?: boolean;
  is_connection_creation_restricted_for_sub_orgs?: boolean;
}
